import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-action-complete',
  templateUrl: './alert-action-complete.component.html',
  styleUrls: ['./alert-action-complete.component.scss']
})
export class AlertActionCompleteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
